import { getCookie } from "services/cookies-service";
import { CONTACT_SALES_FORM_DATA } from "constants/cookies";
import { trackEvent } from "services/bigbrain-service";
import { ADA_CHATBOT_TRIGGERED, ADA_META_DATA_ERROR } from "constants/bigbrain-event-types";
import { ChatSourceName, triggerChat } from "@mondaydotcomorg/chat-client";
const CHATBOT_SCRIPT_URL = "https://microfrontends.monday.com/scripts/growth-cx-mf-renderer.js";
export const enableBotOnPage = (localeId)=>{
    addBotConfig(localeId);
    addBotScript();
};
export const handleChatReady = ()=>{
    let metaData = {};
    try {
        metaData = JSON.parse(getCookie(CONTACT_SALES_FORM_DATA));
    } catch (error) {
        trackEvent(ADA_META_DATA_ERROR, {
            kind: error
        });
    }
    triggerChat(ChatSourceName === null || ChatSourceName === void 0 ? void 0 : ChatSourceName.CONTACT_SALES_HOMEPAGE, metaData);
    trackEvent(ADA_CHATBOT_TRIGGERED);
};
const addBotConfig = (localeId)=>{
    window.chatConfig = {
        hideCTA: true,
        adaSetting: {
            language: localeId
        }
    };
};
const addBotScript = ()=>{
    if (document.querySelector(`script[src="${CHATBOT_SCRIPT_URL}"]`)) return;
    const scriptElement = document.createElement("script");
    scriptElement.src = CHATBOT_SCRIPT_URL;
    scriptElement.defer = true;
    document.body.appendChild(scriptElement);
};
